import { render, staticRenderFns } from "./navigation-tpl.vue?vue&type=template&id=03bd5184&scoped=true"
import script from "./navigation-tpl.vue?vue&type=script&lang=js"
export * from "./navigation-tpl.vue?vue&type=script&lang=js"
import style0 from "./navigation-tpl.vue?vue&type=style&index=0&id=03bd5184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd5184",
  null
  
)

export default component.exports